import { Injectable } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { QuestionGradingPreset } from '@examdojo/models/question';
import { UserStoreModel } from '@examdojo/models/user';
import { CurrentReviewHttpModel } from '../../review-item';
import { ReviewSolutionCaptureDialogComponent } from './review-solution-capture-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ReviewSolutionCaptureDialogService extends AbstractDialogService<
  ReviewSolutionCaptureDialogInput,
  boolean | QuestionGradingPreset
> {
  readonly id = 'solution-capture';
  protected readonly component = ReviewSolutionCaptureDialogComponent;

  override openDialog({ input }: { input: ReviewSolutionCaptureDialogInput; options?: DialogOptions }) {
    return super.openDialog({
      options: {
        ...this.options,
        componentProps: {
          userId: input.userId,
          reviewSession: input.reviewSession,
        },
      },
    });
  }
}

export interface ReviewSolutionCaptureDialogInput {
  userId: UserStoreModel['id'];
  reviewSession: CurrentReviewHttpModel['review_session'];
}
